import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function redirectToHomeIfAuthorised(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const authorisationStore = useAuthorisationStore();
  const authClient = await getAuthClient();
  const token = await authClient.getAccessToken();
  if (token) {
    if (authorisationStore.redirectToAfterLoginUrl === "/auth/login") {
      authorisationStore.redirectToAfterLoginUrl = undefined;
    }

    const redirectUrl = authorisationStore.getRedirectToAfterLoginUrl || { name: "dashboard" };
    return next(redirectUrl);
  }
  return next();
}
